<template>
  <div class="relative">
    <div
      class="slot mb-4 shadow-md rounded-md overflow-hidden flex cursor-pointer"
      @click="$emit('click')"
    >
      <KImage :src="image" style="min-width: 3.75rem;" />
      <div
        style="width: 5.625rem;"
        class="relative py-0.5 px-1 flex flex-col justify-between"
      >
        <span class="text-xs font-semibold overflow-hidden truncate">
          {{ title }}
        </span>
        <div style="font-size: 8px;">
          <div class="flex justify-between">
            <span>Proteins</span>
            <span>{{ proteins }}g</span>
          </div>
          <div class="flex justify-between">
            <span>Fats</span>
            <span>{{ fats }}g</span>
          </div>
          <div class="flex justify-between">
            <span>Carbohydrates</span>
            <span>{{ carbohydrates }}g</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!pastMeal" class="absolute -top-2 -right-1.5">
      <FontAwesomeIcon
        :icon="['far', 'times-circle']"
        class="text-secondary rounded-full bg-primary font-black cursor-pointer"
        @click="removeMealFromList"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Meal",
  components: {},
  props: {
    meal: {
      type: Object,
      default: () => {}
    },
    pastMeal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    image() {
      return this.meal.image;
    },
    title() {
      return this.meal.title;
    },
    proteins() {
      return this.meal.proteins;
    },
    fats() {
      return this.meal.fats;
    },
    carbohydrates() {
      return this.meal.carbohydrates;
    }
  },
  data() {
    return {};
  },
  methods: {
    removeMealFromList(event) {
      event.preventDefault();
      this.$emit("removeMealList", this.meal.id);
    }
  },
  created() {}
};
</script>

<style></style>
